// ======================================
// Shared UI Components
// ======================================

import { headerMenuData } from './data.js';
import { isAuthenticated, getUser, isAdmin, isStaff, logout } from './lib/auth.js';

// Icons (SVG strings)
export const icons = {
  menu: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>`,
  x: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`,
  check: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>`,
  arrowRight: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>`,
  arrowLeft: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>`,
  phone: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>`,
  mail: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>`,
  mapPin: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>`,
  clock: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>`,
  home: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>`,
  star: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>`,
  shield: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>`,
  award: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline></svg>`,
  users: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>`,
  calendar: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>`,
  tool: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>`,
  eye: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>`,
  calculator: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="2" width="16" height="20" rx="2"/><line x1="8" x2="16" y1="6" y2="6"/><line x1="16" x2="16" y1="14" y2="18"/><path d="M16 10h.01"/><path d="M12 10h.01"/><path d="M8 10h.01"/><path d="M12 14h.01"/><path d="M8 14h.01"/><path d="M12 18h.01"/><path d="M8 18h.01"/></svg>`,
  packages: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16.5 9.4 7.55 4.24"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" x2="12" y1="22.08" y2="12"/></svg>`,
  sparkles: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/><path d="M5 3v4"/><path d="M19 17v4"/><path d="M3 5h4"/><path d="M17 19h4"/></svg>`,
  facebook: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>`,
  instagram: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>`,
  youtube: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon></svg>`,
  messageCircle: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>`,
  chevronDown: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>`
};

// Header Component
export function renderHeader() {
  const user = getUser();
  const userInitials = user ? user.name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase() : '';
  const isAdminUser = isAdmin() || isStaff();

  return `
    <header class="header" id="header">
      <div class="header-inner">
        <a href="/" class="header-logo">
          <img src="/logo.png" alt="NammaVeetuInteriors" class="header-logo-img">
        </a>
        
        <nav class="header-nav">
          <a href="/" class="nav-link">Home</a>
          
          <div class="nav-item">
            <button class="nav-link nav-dropdown-toggle">
              Design Ideas ${icons.chevronDown}
            </button>
            <div class="mega-menu">
              <div class="mega-menu-content">
                ${headerMenuData.designIdeas.categories.map(cat => `
                  <div class="mega-menu-column">
                    <h4 class="mega-menu-heading">${cat.name}</h4>
                    <ul class="mega-menu-list">
                      ${cat.items.map(item => `
                        <li><a href="/design-ideas/${item.toLowerCase().replace(/\s+/g, '-')}" class="mega-menu-link">${item}</a></li>
                      `).join('')}
                    </ul>
                  </div>
                `).join('')}
              </div>
            </div>
          </div>

          <div class="nav-item">
            <button class="nav-link nav-dropdown-toggle">
              Cities ${icons.chevronDown}
            </button>
             <div class="nav-dropdown">
                <ul class="nav-dropdown-list">
                    ${headerMenuData.cities.map(city => `
                        <li><a href="/locations/${city.toLowerCase()}" class="nav-dropdown-link">${city}</a></li>
                    `).join('')}
                </ul>
            </div>
          </div>

          <a href="/projects" class="nav-link">Projects</a>
          
           <div class="nav-item">
            <button class="nav-link nav-dropdown-toggle">More ${icons.chevronDown}</button>
             <div class="nav-dropdown">
                <ul class="nav-dropdown-list">
                    ${headerMenuData.more.map(item => `
                        <li><a href="${item.link}" class="nav-dropdown-link">${item.name}</a></li>
                    `).join('')}
                </ul>
            </div>
          </div>

        </nav>
        
        <div class="header-actions">
           <a href="/contact" class="btn btn-sm btn-accent shop-btn hidden-md">Shop Furnishings <span class="badge-new">NEW</span></a>
           
          <a href="/contact" class="btn btn-primary header-cta btn-shimmer">Consult Online Now</a>
          
          ${user ? `
            <div class="user-menu">
                <button class="user-menu-btn" id="user-menu-btn" aria-label="User Menu">
                    <div class="user-avatar">${userInitials}</div>
                </button>
                <div class="user-dropdown" id="user-dropdown">
                    <div class="user-dropdown-header">
                        <p class="user-name">${user.name}</p>
                        <p class="user-email">${user.email}</p>
                    </div>
                    <ul class="user-dropdown-list">
                        <li><a href="/profile" class="user-dropdown-link">My Profile</a></li>
                        ${isAdminUser ? `
                            <li><a href="/admin" class="user-dropdown-link admin-link">
                                ${icons.shield} Admin Panel
                            </a></li>
                        ` : ''}
                        <li><button id="logout-btn" class="user-dropdown-link logout-btn">Logout</button></li>
                    </ul>
                </div>
            </div>
          ` : `
            <a href="/login" class="btn btn-outline-primary btn-sm login-btn">Login / Sign Up</a>
          `}

          <button class="mobile-menu-btn" id="mobile-menu-btn" aria-label="Toggle menu">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
      
      <nav class="mobile-nav" id="mobile-nav">
        <a href="/" class="mobile-nav-link">Home</a>
        <div class="mobile-nav-group">
            <button class="mobile-nav-accordion">Design Ideas ${icons.chevronDown}</button>
            <div class="mobile-nav-panel">
                ${headerMenuData.designIdeas.categories.map(cat => `
                    <div class="mobile-nav-subgroup">
                        <h5 class="mobile-nav-subtitle">${cat.name}</h5>
                        ${cat.items.map(item => `
                            <a href="/design-ideas/${item.toLowerCase().replace(/\s+/g, '-')}" class="mobile-nav-sublink">${item}</a>
                        `).join('')}
                    </div>
                `).join('')}
            </div>
        </div>
        <div class="mobile-nav-group">
             <button class="mobile-nav-accordion">Cities ${icons.chevronDown}</button>
             <div class="mobile-nav-panel">
                ${headerMenuData.cities.map(city => `
                    <a href="/locations/${city.toLowerCase()}" class="mobile-nav-sublink">${city}</a>
                `).join('')}
             </div>
        </div>
        <a href="/projects" class="mobile-nav-link">Projects</a>
        <a href="/blog" class="mobile-nav-link">Magazine</a>
        <a href="/contact" class="mobile-nav-link">Contact</a>
        
        <div class="mobile-nav-auth">
            ${user ? `
                 <a href="/profile" class="mobile-nav-link">My Profile</a>
                 ${isAdminUser ? `<a href="/admin" class="mobile-nav-link admin-link">Admin Panel</a>` : ''}
                 <button id="mobile-logout-btn" class="mobile-nav-link logout-btn">Logout</button>
            ` : `
                 <a href="/login" class="btn btn-outline-primary mobile-auth-btn">Login / Sign Up</a>
            `}
        </div>

        <a href="/contact" class="btn btn-primary mobile-nav-cta">Consult Online Now</a>
      </nav>
    </header>
  `;
}

// Footer Component
export function renderFooter() {
  const currentYear = new Date().getFullYear();

  return `
    <footer class="footer">
      <div class="container">
        <div class="footer-grid">
          <div class="footer-brand">
            <a href="/" class="footer-logo">
              <img src="/logo.png" alt="NammaVeetuInteriors" class="footer-logo-img">
            </a>
            <p class="footer-description">
              Transform your home into a space that reflects your style. Premium interior design 
              services with transparent pricing and guaranteed timelines.
            </p>
            <div class="footer-social">
              <a href="#" class="social-link" aria-label="Facebook">${icons.facebook}</a>
              <a href="#" class="social-link" aria-label="Instagram">${icons.instagram}</a>
              <a href="#" class="social-link" aria-label="YouTube">${icons.youtube}</a>
            </div>
          </div>
          
          <div class="footer-section">
            <h4>Quick Links</h4>
            <div class="footer-links">
              <a href="/services" class="footer-link">Our Services</a>
              <a href="/packages" class="footer-link">Packages</a>
              <a href="/estimator" class="footer-link">Cost Estimator</a>
              <a href="/projects" class="footer-link">Portfolio</a>
              <a href="/about" class="footer-link">About Us</a>
              <a href="/blog" class="footer-link">Blog</a>
              <a href="/contact" class="footer-link">Contact Us</a>
            </div>
          </div>
          
          <div class="footer-section">
            <h4>Services</h4>
            <div class="footer-links">
              <a href="/services/modular-kitchen" class="footer-link">Modular Kitchen</a>
              <a href="/services/wardrobe" class="footer-link">Wardrobes</a>
              <a href="/services/living-room" class="footer-link">Living Room</a>
              <a href="/services/bedroom" class="footer-link">Bedroom</a>
              <a href="/services/full-home" class="footer-link">Full Home</a>
            </div>
          </div>
          
          <div class="footer-section">
            <h4>Contact Us</h4>
            <div class="footer-contact-item">
              ${icons.phone}
              <div class="footer-contact-text">
                <a href="tel:+918220595978">+91 82205 95978</a>
              </div>
            </div>
            <div class="footer-contact-item">
              ${icons.mail}
              <div class="footer-contact-text">
                <a href="mailto:hello@nammaveetuinteriors.com">hello@nammaveetuinteriors.com</a>
              </div>
            </div>
            <div class="footer-contact-item">
              ${icons.mapPin}
              <div class="footer-contact-text">
                123 Design Street, Anna Nagar<br>Chennai - 600040
              </div>
            </div>
            
            <div class="footer-badges">
              <div class="trust-badge">
                ${icons.shield}
                <span>10 Year Warranty</span>
              </div>
              <div class="trust-badge">
                ${icons.award}
                <span>500+ Projects</span>
              </div>
            </div>
          </div>
        </div>
        
        <div class="footer-bottom">
          <p class="footer-copyright">© ${currentYear} NammaVeetuInteriors. All rights reserved.</p>
          <div class="footer-legal">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Service</a>
            <a href="/refund-policy">Refund Policy</a>
          </div>
        </div>
      </div>
    </footer>
  `;
}

// Sticky CTA Component
export function renderStickyCTA() {
  return `
    <div class="sticky-cta" id="sticky-cta">
      <div class="sticky-cta-inner">

        <a href="tel:+918220595978" class="sticky-cta-btn sticky-cta-secondary">
          ${icons.phone}
          <span>Call Now</span>
        </a>
        <button class="sticky-cta-btn sticky-cta-primary" data-open-modal="lead-modal">
          ${icons.messageCircle}
          <span>Get Quote</span>
        </button>
      </div>
    </div>
  `;
}

// Bottom Navigation Component (Mobile)
export function renderBottomNav() {
  const activePath = window.location.pathname;

  const navItems = [
    { name: 'Home', icon: icons.home, link: '/', active: activePath === '/' },
    { name: 'Ideas', icon: icons.sparkles, link: '/design-ideas', active: activePath.startsWith('/design-ideas') },
    { name: 'More', icon: icons.menu, link: '/contact', active: activePath.startsWith('/contact') }
  ];

  return `
    <nav class="bottom-nav">
      ${navItems.map(item => `
        ${item.link === '#' ?
      `<button class="bottom-nav-item ${item.active ? 'active' : ''}" id="${item.id}">
             ${item.icon}
             <span>${item.name}</span>
           </button>` :
      `<a href="${item.link}" class="bottom-nav-item ${item.active ? 'active' : ''}">
             ${item.icon}
             <span>${item.name}</span>
           </a>`
    }
      `).join('')}
    </nav>
  `;
}

// Lead Modal Component
export function renderLeadModal() {
  return `
    <div class="modal-overlay" id="lead-modal">
      <div class="modal">
        <div class="modal-header">
          <div>
            <h3 class="modal-title">Get Free Design Consultation</h3>
            <p class="modal-subtitle">Share your details and we'll call you back</p>
          </div>
          <button class="modal-close" data-close-modal>
            ${icons.x}
          </button>
        </div>
        <div class="modal-body">
          <form class="modal-form" id="lead-form">
            <div class="form-group">
              <label class="form-label" for="lead-name">Full Name *</label>
              <input type="text" id="lead-name" name="name" class="form-input" placeholder="Enter your name" required>
            </div>
            <div class="form-group">
              <label class="form-label" for="lead-phone">Phone Number *</label>
              <input type="tel" id="lead-phone" name="phone" class="form-input" placeholder="+91 82205 95978" required>
            </div>
            <div class="form-group">
              <label class="form-label" for="lead-email">Email (Optional)</label>
              <input type="email" id="lead-email" name="email" class="form-input" placeholder="your@email.com">
            </div>
            <div class="form-group">
              <label class="form-label" for="lead-property">Property Type</label>
              <select id="lead-property" name="property" class="form-select">
                <option value="">Select property type</option>
                <option value="1bhk">1 BHK</option>
                <option value="2bhk">2 BHK</option>
                <option value="3bhk">3 BHK</option>
                <option value="4bhk+">4 BHK+</option>
                <option value="villa">Villa</option>
              </select>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="submit" form="lead-form" class="btn btn-primary btn-lg modal-submit">
            Get Free Consultation
          </button>
          <p class="modal-disclaimer">
            By submitting, you agree to our privacy policy. We'll never spam you.
          </p>
        </div>
      </div>
    </div>
  `;
}

// Service Card Component
export function renderServiceCard(service) {
  return `
    <a href="/services/${service.slug}" class="service-card">
      <img src="${service.image}" alt="${service.title}" class="service-card-img" loading="lazy">
      <div class="service-card-body">
        <h3 class="service-card-title">${service.title}</h3>
        <p class="service-card-desc">${service.description}</p>
        <span class="service-card-link">
          Explore ${icons.arrowRight}
        </span>
      </div>
    </a>
  `;
}

// Package Card Component
export function renderPackageCard(pkg, featured = false) {
  return `
    <div class="package-card ${featured ? 'featured' : ''}">
      ${featured ? '<span class="package-badge">Most Popular</span>' : ''}
      <div class="package-header">
        <p class="package-type">${pkg.type}</p>
        <h3 class="package-name">${pkg.name}</h3>
        <div class="package-price">
          <span class="package-price-amount">₹${pkg.price}</span>
          <span class="package-price-suffix">Lakhs onwards</span>
        </div>
      </div>
      <div class="package-features">
        ${pkg.features.map(f => `
          <div class="package-feature ${f.included ? '' : 'excluded'}">
            ${f.included ? icons.check : icons.x}
            <span>${f.name}</span>
          </div>
        `).join('')}
      </div>
      <a href="/contact" class="btn ${featured ? 'btn-primary' : 'btn-secondary'} package-cta">
        Get Quote
      </a>
    </div>
  `;
}

// Project Card Component
export function renderProjectCard(project) {
  return `
    <a href="/projects/${project.slug}" class="project-card">
      <div class="project-card-img-wrapper">
        <img src="${project.image}" alt="${project.title}" class="project-card-img" loading="lazy">
        <div class="project-card-overlay"></div>
        <span class="project-card-view">
          ${icons.eye}
          View Project
        </span>
      </div>
      <div class="project-card-body">
        <h3 class="project-card-title">${project.title}</h3>
        <div class="project-card-meta">
          <span class="project-card-tag">
            ${icons.home}
            ${project.bhk}
          </span>
          <span class="project-card-tag">
            ${icons.mapPin}
            ${project.location}
          </span>
        </div>
      </div>
    </a>
  `;
}

// Testimonial Card Component
export function renderTestimonialCard(testimonial) {
  const stars = Array(5).fill(icons.star).join('');

  return `
    <div class="testimonial-card">
      <p class="testimonial-quote">${testimonial.quote}</p>
      <div class="testimonial-author">
        <img src="${testimonial.avatar}" alt="${testimonial.name}" class="testimonial-avatar">
        <div>
          <p class="testimonial-name">${testimonial.name}</p>
          <p class="testimonial-project">${testimonial.project}</p>
          <div class="testimonial-rating">${stars}</div>
        </div>
      </div>
    </div>
  `;
}

// Initialize UI interactions
export function initUI() {
  // Mobile menu toggle
  const mobileMenuBtn = document.getElementById('mobile-menu-btn');
  const bottomNavMenuBtn = document.getElementById('bottom-nav-menu');
  const mobileNav = document.getElementById('mobile-nav');

  const toggleMenu = () => {
    if (mobileMenuBtn) mobileMenuBtn.classList.toggle('active');
    if (mobileNav) mobileNav.classList.toggle('active');
    document.body.classList.toggle('no-scroll');
  };

  if (mobileMenuBtn && mobileNav) {
    mobileMenuBtn.addEventListener('click', toggleMenu);
  }

  if (bottomNavMenuBtn && mobileNav) {
    bottomNavMenuBtn.addEventListener('click', (e) => {
      e.preventDefault();
      toggleMenu();
    });
  }

  if (mobileNav) {
    // Mobile Accordions
    const accordions = mobileNav.querySelectorAll('.mobile-nav-accordion');
    accordions.forEach(acc => {
      acc.addEventListener('click', () => {
        acc.classList.toggle('active');
        const panel = acc.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    });
  }

  // User Dropdown Toggle (Desktop)
  const userMenuBtn = document.getElementById('user-menu-btn');
  const userDropdown = document.getElementById('user-dropdown');

  if (userMenuBtn && userDropdown) {
    userMenuBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      userDropdown.classList.toggle('active');
    });

    document.addEventListener('click', (e) => {
      if (!userMenuBtn.contains(e.target) && !userDropdown.contains(e.target)) {
        userDropdown.classList.remove('active');
      }
    });
  }

  // Logout Handler
  const logoutBtns = document.querySelectorAll('.logout-btn');
  logoutBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      logout();
    });
  });

  // Header scroll effect
  const header = document.getElementById('header');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    });
  }

  // Sticky CTA visibility
  const stickyCTA = document.getElementById('sticky-cta');
  if (stickyCTA) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 400) {
        stickyCTA.classList.add('visible');
      } else {
        stickyCTA.classList.remove('visible');
      }
    });
  }

  // Modal handlers
  document.querySelectorAll('[data-open-modal]').forEach(btn => {
    btn.addEventListener('click', () => {
      const modalId = btn.getAttribute('data-open-modal');
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.classList.add('active');
        document.body.classList.add('no-scroll');
      }
    });
  });

  document.querySelectorAll('[data-close-modal]').forEach(btn => {
    btn.addEventListener('click', () => {
      const modal = btn.closest('.modal-overlay');
      if (modal) {
        modal.classList.remove('active');
        document.body.classList.remove('no-scroll');
      }
    });
  });

  // Close modal on overlay click
  document.querySelectorAll('.modal-overlay').forEach(overlay => {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        overlay.classList.remove('active');
        document.body.classList.remove('no-scroll');
      }
    });
  });

  // Lead form submission - connected to backend API
  const leadForm = document.getElementById('lead-form');
  if (leadForm) {
    leadForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      const submitBtn = document.querySelector('.modal-submit');
      const originalText = submitBtn?.textContent || 'Get Free Consultation';
      const modal = document.getElementById('lead-modal');

      // Get form data
      const leadData = {
        name: document.getElementById('lead-name')?.value?.trim() || '',
        phone: document.getElementById('lead-phone')?.value?.trim() || '',
        email: document.getElementById('lead-email')?.value?.trim() || '',
        property_type: document.getElementById('lead-property')?.value || '',
        source: 'modal'
      };

      // Basic validation
      if (!leadData.name || !leadData.phone) {
        alert('Please fill in your name and phone number');
        return;
      }

      // Show loading state
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = '<span class="spinner"></span> Submitting...';
      }

      try {
        // Import API dynamically to avoid circular imports
        const { leadsAPI } = await import('./lib/api.js');
        await leadsAPI.create(leadData);

        // Show success message
        if (modal) {
          modal.querySelector('.modal-body').innerHTML = `
            <div style="text-align: center; padding: var(--space-8);">
              <div style="width: 64px; height: 64px; background: rgba(46, 125, 74, 0.1); border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto var(--space-6);">
                ${icons.check}
              </div>
              <h3 style="font-size: var(--text-xl); margin-bottom: var(--space-2);">Thank You!</h3>
              <p style="color: var(--color-text-muted);">We'll call you within 24 hours to schedule your free consultation.</p>
            </div>
          `;
          modal.querySelector('.modal-footer').style.display = 'none';

          setTimeout(() => {
            modal.classList.remove('active');
            document.body.classList.remove('no-scroll');
          }, 3000);
        }
      } catch (error) {
        console.error('Lead submission failed:', error);
        alert('Failed to submit. Please try again or call us directly.');
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }
      }
    });
  }
}
